/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TagDropdownPerson200,
  GetApiV1TagDropdownPerson401,
  GetApiV1TagDropdownPerson500,
  GetApiV1TagDropdownPersonQueryParams,
  GetApiV1TagDropdownPersonQueryResponse,
} from "../../types/tagRegistroController/GetApiV1TagDropdownPerson.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1TagDropdownPersonQueryParamsSchema = z
  .object({
    personId: z.optional(z.coerce.number().int()),
    includeTags: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1TagDropdownPersonQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TagDropdownPerson200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1TagDropdownPerson200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TagDropdownPerson401Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdownPerson401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TagDropdownPerson500Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdownPerson500>;

export const getApiV1TagDropdownPersonQueryResponseSchema = z.lazy(
  () => getApiV1TagDropdownPerson200Schema,
) as unknown as ToZod<GetApiV1TagDropdownPersonQueryResponse>;
